export default "__VITE_ASSET__B0z3kOXu__"